export default "__VITE_ASSET__8fc8e41f__"